<template>
    <div class="mx-8">
        <v-server-table
            :url="apiUrl"
            :columns="columns.data"
            :options="options"
            ref="table"
            @loaded="tableLoaded"
            @row-click="rowClicked"
        >
            <template v-slot:month_name="props">
                <div class="">
                    {{ props.row.month_name }}
                </div>
            </template>

            <template v-slot:lock_status="props">
                <div class="">
                    <span v-if="props.row.is_locked">Zaključano</span>
                    <span v-else>Otključano</span>
                </div>
            </template>

            <template v-slot:lock-actions="props">
                <div class="flex">
                    <button v-if="!props.row.is_locked" @click="lockMonth(props.row.month, props.row.year)">Zaključaj
                    </button>
                    <button v-else @click="unlockMonth(props.row.month, props.row.year)">Otključaj</button>
                </div>
            </template>

            <template v-slot:status="props">
                <slot name="status" :props="props">
                    <div class="">
                        <span v-if="props.row.status == '1'">Aktivno</span>
                        <span v-else>Neaktivno</span>
                    </div>
                </slot>
            </template>
            <template v-slot:tech_users="props">
                <slot name="tech_users" :props="props">
                    <div class="">
                        <span v-if="props.row.tech_users == '1'">Tehničko osoblje</span>
                        <span v-else>Standardno osoblje</span>
                    </div>
                </slot>
            </template>
            <template v-slot:available="props">
                <slot name="available" :props="props">
                    <div class="">
                        <span v-if="props.row.available == '1'">Raspoloživ</span>
                        <span v-else>Neraspoloživ</span>
                    </div>
                </slot>
            </template>
            <template v-slot:actions="props">
                <slot name="actions" :props="props">
                    <div class="flex">
                        <a v-if="showEndPoint" class="ml-auto text-primary"
                           :href="route(showEndPoint + '.show', props.row.id)">
                            <img src="/svg/list_arrow.svg" alt=">">
                        </a>
                    </div>
                </slot>
            </template>
            <template v-slot:deleted_at="props">
                <slot name="deleted_at" :props="props">{{ props.row.deleted_at ? 'Neaktivan' : 'Aktivan' }}</slot>
            </template>
        </v-server-table>
        <div class="absolute top-0 left-0 flex mt-12 ml-20">
            <img
                class="pr-3"
                src="/assets/icon_search.svg"
                alt="Search"
            />
            <input
                class="h-full menu-search"
                type="text"
                placeholder="Pretražite pojam iz tablice"
                @input="searchQuery"
            />
        </div>
    </div>
</template>

<script>

export default {
    components: {},

    props: {
        filters: {
            type: Array,
            default: () => ([])
        },
        columns: {
            required: true,
            type: Object,
        },
        apiUrl: {
            required: true,
            type: String,
        },
        perPage: {
            required: false,
            type: Number,
            default: null,
        },
        sortColumn: {
            required: false,
            type: String,
            default: null,
        },
        sortType: {
            required: false,
            type: String,
            default: 'asc',
        },
        showEndPoint: {
            type: String,
            default: null,
        },
        editEndPoint: {
            type: Boolean,
            default: false,
        },
        lockEndPoint: {
            required: true,
            type: String,
        },
        unlockEndPoint: {
            required: true,
            type: String,
        },
        initialFilter: {
            type: Object,
            default: () => ({}),
        },
        disableRowClick: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            options: {
                texts: {
                    filterPlaceholder: 'Search',
                    limit: 'Items per page: ',
                    count: '{count} zapisa',
                    noResults: 'Ne postoje zapisi',
                    loading: 'Učitavam...',
                    first: 'Prva',
                    last: 'Zadnja',
                },
                pagination: {
                    nav: 'scroll',
                    edge: true,
                },
                perPageValues: [],
                customFilters: ['query', 'filters'],
                serverMultiSorting: true,
                resizableColumns: false,
                // filterable: false,
            },
        }

    },

    created() {
        // if (this.modalFilterData) {
        //     this.modal.data = this.modalFilterData
        // }
        this.showLoader();

        window.axios.defaults.headers.Authorization = `Bearer ${window.App.user.api_token}`
        window.axios.defaults.headers.Accept = 'application/json'

        if (this.filters) {
            this.options.initFilters = {filters: []};

            this.filters.forEach(filter => {
                this.options.initFilters.filters.push(
                    {
                        model: filter.model,
                        column: filter.column,
                        value: filter.value
                    }
                )
            });
        }

        if (this.initialFilter.model) {
            this.options.initFilters = {
                role: {
                    column: this.initialFilter.column,
                    value: this.initialFilter.value
                }
            }
        }

        if (this.columns && this.columns.headings) {
            this.options.headings = this.columns.headings
        }

        if (this.perPage) {
            this.options.perPage = this.perPage
        }

        if (this.sortColumn) {
            this.options.orderBy = {
                ascending: this.sortType == 'asc' ? true : false,
                column: this.sortColumn,
            }
        }
    },

    mounted() {
        window.Bus.$on('search-query', (payload) => {
            Event.$emit('vue-tables.filter::query', payload)
        })
    },

    destroyed() {
        let emitData = {
            loaded: false,
        }
        window.Bus.$emit('dataTableLoaded', emitData);
    },

    methods: {
        searchQuery(e) {
            Event.$emit('vue-tables.filter::query', e.target.value)
        },

        // Handles what happens on row click on data table
        rowClicked(props) {
            if (this.disableRowClick || !props.row.id) {
                return;
            }
            if (this.editEndPoint) {
                window.location.href = route(this.showEndPoint + '.edit', props.row.id)
            } else {
                window.location.href = route(this.showEndPoint + '.show', props.row.id)
            }
        },

        lockMonth(month, year) {
            const url = route(this.lockEndPoint, {month: month, year: year});
            window.axios.post(url).then(response => {
                this.$refs.table.refresh();
            }).catch(error => {
                console.error("Failed to lock the month:", error);
            });
        },

        unlockMonth(month, year) {
            const url = route(this.unlockEndPoint, {month: month, year: year});
            window.axios.post(url).then(response => {
                console.log(response);
                this.$refs.table.refresh();
            }).catch(error => {
                console.error("Failed to unlock the month:", error);
            });
        },
        // Handles what happens when table loads
        tableLoaded() {
            this.hideLoader();
            let emitData = {
                loaded: true,
            }
            window.Bus.$emit('dataTableLoaded', emitData);
        },
    },
}
</script>
<style lang="scss">

</style>
